import React, { useEffect, useState } from "react";
import { questionnaireData } from "../data/QuestionnaireData";
import DataGridComponent from "../commonfields/grid/DataGridComponent";
import { defaultGridConfig } from "../config/DataGridConfig";
import { questionnaireColumns } from "../config/QuestionnaireConfig";
import { useNavigate } from "react-router-dom";
import { CellClickArgs, CellMouseEvent } from "react-data-grid";
import { RoutesEnum, SidebarEnum } from "../tsmodels/RoutesModel";
import "./pages.scss";
import { getSidebarIcon } from "../config/SideBarConfig";
import TextInput from "../commonfields/inputs/TextInput";
import { ReactComponent as SearchIcon } from "../images/search-icon.svg"
import Appservice from "../services/appservice";
import { getQuestionarieList } from "../helpers/ServiceSections";
import { IQuestionnaireModel } from "../tsmodels/QuestionnaireModel";
import { catchError } from "../utils/Utils";
import { AxiosError } from "axios";

const QuestionnaireListPage = () => {
  const navigate = useNavigate();
  const service = new Appservice();


  // states
  const [questionnaireSearch, setQuestionnaireSearch] = useState("");
  const [questionnaire, setQuestionnaire] = useState<IQuestionnaireModel[]>([])
  const [loader, setLoader] = useState<boolean>(false)

  // const
  // questionnaire columns for the list
  const columns = questionnaireColumns;

  // questionnaire data for the list
  const data = questionnaireData as any;

  // questionnaire data for the list
  const config = { ...defaultGridConfig, sortable: true };

  // funcs - handlers
  const handleQuestionnaireSearch = (e: any) => {
    setQuestionnaireSearch(e?.target?.value);
  };  

  const onCellClick = (
    args: CellClickArgs<any, unknown>,
    event: CellMouseEvent
  ) => {
    args?.row?.questionnaireId &&
      navigate(`/${RoutesEnum.QUESTIONNAIRE}/${RoutesEnum.CATEGORIES}/${args?.row?.questionnaireName}/${args?.row?.questionnaireId}`);
  };
  // funcs-Api call
   
  const getQuestion = () => {
    const payLoad = getQuestionarieList;
    setLoader(true);
    service
      .getQuestionnaireList(payLoad)
      .then((res) => {
        setQuestionnaire(res?.data)
   
      })
     
      .catch((error: AxiosError) => {
        catchError(error, true);
      })

      .finally(() => {
        setLoader(false);
      });
  };
  

  // funcs - render 
  // useEffect
  useEffect(() => {
    getQuestion();
  }, []);
  return (
    <div className="questionnaire-list-page">
      <div className="subheader-container">
        <div className="subheader-left">
          <div className="subheader-icon">
            {getSidebarIcon(SidebarEnum.QUESTIONNAIRE)}
          </div>
          <div className="subheader-title">Questionnaire Library</div>
        </div>
        <div className="subheader-right">
          <div className="subheader-input-container">
            <TextInput
              className="subheader-input"
              value={questionnaireSearch}
              onChange={handleQuestionnaireSearch}
              placeholder="Search for a questionnaire"
            />
            <SearchIcon className="search-icon" />
          </div>
        </div>
      </div>
      <div className="questionnaire-list-table">
        <DataGridComponent
          gridRows={questionnaire as any}
          gridColumns={columns}
          config={config}
          onCellClick={onCellClick}
          searchParams={{
            fieldName: 'questionnaireName',
            value: questionnaireSearch
          }}
        />
      </div>
    </div>
  );
};

export default QuestionnaireListPage;
